const aboutMeData = [
    {
        'title': 'Developer',
        'techStack': ['React', 'NextJs', 'HTML5', 'JavaScript', 'CSS3', 'Python', 'Django', 'MYSQL', 'Postgres', 'Browserstack', 'Jest', 'Wordpress', 'MUI', 'FireBase', 'Google Auth', 'Git'],
        'about': 'Passionate about the front-end, I strive to seek out new technologies that allow me to create engaging and fun experiences. I like to get stuck into learning new concepts and tinkering with alternate ways of doing things.',
        'expect': ['User focused problem solving', 'Test focused', 'Adapt quickly to new technologies', 'Functional and concise code']

    },
    {
        'title': 'Designer',
        'techStack': ['Branding', 'Logo Design', 'Social Media', 'Print-Design', 'Poster Design', 'Photography', 'Photoshop', 'InDesign', 'Illustrator', 'Adobe XD', 'Aftereffects', 'Lightroom'],
        'about': 'By nature I enjoy clean legible design language that serves a direct purpose. But ultimately I am mostly interested in the fun of something, how it makes the user or audience feel, what kind of response can be created',
        'expect': ['Clean but exciting design language', 'Researched, thoughtful and deliberate', 'Contemporary and on trend']
    },
    {
        'title': 'Dog Enthusiast',
        'techStack': ['Spoodle', 'Fetching', 'Borking', 'Snoring', 'Biting', 'Burping', 'Eating', 'Begging', 'Giving Paw', 'Farting'],
        'about': 'I just love my dog Rigby, he is a very good boy',
        'expect': ['Never dropping the ball', 'Running away', 'Sneaking into bed']
    },

]

export default aboutMeData;